<template>
  <v-app>
    <div v-if="!$route.meta.hideNavbar">
      <AppBar v-if="!$route.meta.showBack" />
      <NavigationTopBar v-else />
    </div>
    <v-main :class="!$route.meta.hideNavbar && !$route.meta.hideBottomNav ? 'pt-10 pb-10' : 'mt-0 ' + $route.meta.background">
          <router-view/>
    </v-main>
    <div v-if="!$route.meta.hideBottomNav">
      <NavigationBar />
    </div>
    <snack-bar />
  </v-app>
</template>

<script>
import AppBar from '@/components/global/AppBar.vue'
import NavigationBar from  '@/components/global/NavigationBar.vue'
import NavigationTopBar from  '@/components/global/NavigationTopBar.vue'
import SnackBar from './components/global/SnackBar.vue';
export default {
  name: 'App',
  components : {AppBar, NavigationBar, NavigationTopBar, SnackBar},
  data () {
    return { }
  }
};
</script>
